import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { MediaWorkOrder } from 'views/TicketDetails/TicketDetailsContext';


interface IContext {
    isLoading: boolean
    workOrders: IWorkOrder[]
    selectedRowIds: number[]
    selectWorkOrders: (rows: IWorkOrder[]) => void
}


interface IWorkOrder {
    workOrderId: number
    workOrderNumber: string
    articleId: string
    articleModel: string
    articleVersion: string
    articleDescription: string
    orderId: number
    orderNumber: string
    orderType: string
    orderTitle: string
    orderDate: moment.Moment
}

interface IProps {
    children: React.ReactNode
    ticketNumber: string
    selectedRowIds: number[]
    onSelect: (workOrders: MediaWorkOrder[]) => void
}

export let addOrdersContext = React.createContext({} as IContext);

let { Provider } = addOrdersContext;

let AddOrdersProvider: React.FC<IProps> = ({ children, ticketNumber, selectedRowIds, onSelect }) => {

    let [isLoading, setLoading] = useState(true);

    let [workOrders, setWorkOrders] = useState<IWorkOrder[]>([]);


    useEffect(() => {
        doSearch();
    }, [ticketNumber, selectedRowIds])


    let doSearch = async () => {
        try {
            setLoading(true);

            let res = await axios.get('/api/Order/GetOrderRowsFromTicket', { params: { ticketNumber } });

            let { items } = res.data;

            // Ciclo le righe attuali nell'eventualità che sia stata rimossa una commessa che avevo selezionato
            selectedRowIds.forEach(rowId => {
                let found = (items as IWorkOrder[]).find(x => x.workOrderId === rowId);

                if (!found) {
                    let workOrdersToKeep = (items as IWorkOrder[])
                        .filter(x => selectedRowIds.filter(x => x !== rowId).indexOf(x.workOrderId) !== -1);

                    selectWorkOrders(workOrdersToKeep)
                }
            })

            setWorkOrders(items);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let selectWorkOrders = (rows: IWorkOrder[]) => {
        let workOrders = rows.map(x => ({
            articleDescription: x.articleDescription,
            articleId: x.articleId,
            articleModel: x.articleModel,
            articleVersion: x.articleVersion,
            orderDate: moment(x.orderDate).toDate(),
            orderId: x.orderId,
            orderNumber: x.orderNumber,
            orderTitle: x.orderTitle,
            orderType: x.orderType,
            workOrderId: x.workOrderId,
            workOrderNumber: x.workOrderNumber
        } as MediaWorkOrder));

        onSelect(workOrders);
    }

    return (
        <Provider value={{
            workOrders,
            isLoading,
            selectedRowIds,
            selectWorkOrders
        }}>
            {children}
        </Provider>
    );
}

export default AddOrdersProvider;